import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import If from 'components/UI/If/If';

function MenuItem({ externalLink, icon, name, path }) {
  return (
    <li>
      <If test={externalLink}>
        <a href={path} rel="noreferrer" target="_blank">
          <FontAwesomeIcon icon={icon} />
          <span className="ml-1 menuItem">{name}</span>
        </a>
      </If>
      <If test={!externalLink}>
        <Link to={path}>
          <FontAwesomeIcon icon={icon} />
          <span className="ml-1 menuItem">{name}</span>
        </Link>
      </If>
    </li>
  );
}

MenuItem.propTypes = {
  externalLink: PropTypes.bool,
  icon: PropTypes.string,
  name: PropTypes.string,
  path: PropTypes.string
};

MenuItem.defaultProps = {
  externalLink: false,
  icon: '',
  name: '',
  path: ''
};

export default MenuItem;
